define('display/layers/mapTheme',[], function() {
    'use strict';
    var map = {
            style: ['main', 'night'],
            layer: ['basic', 'hybrid', 'labels']
        },
        defaultStylesIndex = 0,
        defaultLayersIndex = 0;

    function validateStyleOrLayer(options, key) {
        if (!options || !options[key]) {
            return false;
        }
        return map[key].indexOf(options[key]) !== -1
    }

    function copyFromOptionsToTheme(options, theme, key) {
        if (validateStyleOrLayer(options, key)) {
            theme[key] = options[key];
        }
    }

    return {
        getTheme: function(optionsHierarchyArray) {
            var i,
                options,
                theme = {
                    style: map.style[defaultStylesIndex],
                    layer: map.layer[defaultLayersIndex]
                },
                length = optionsHierarchyArray ? optionsHierarchyArray.length : 0;
            for (i = 0; i < length; ++i) {
                options = optionsHierarchyArray[i];
                copyFromOptionsToTheme(options, theme, 'style');
                copyFromOptionsToTheme(options, theme, 'layer');
            }
            return theme;
        }
    }
});

